$('[data-marquee] ul').webTicker({
	speed: 140,
	duplicate: true,
	height: '44px'
});
